<template>
  <div class="form-control">
    <label class="label" v-if="props.label" :for="name">
      <span class="label-text text-black">{{ props.label }}</span>
      <span class="label-text-alt" v-if="$slots.labelAlt"><slot name="labelAlt"></slot></span>
    </label>
    <slot></slot>
    <label class="label" v-if="props.description">
      <span class="label-text-alt">
        {{ props.description }}
      </span>
    </label>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  label: {
    type: String
  },
  name: {
    type: String,
    required: true
  },
  description: {
    type: String
  }
})
</script>

<style></style>
